import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IMailReminderExecutorProps } from './IMailReminderExecutorProps';
import { MailReminderExecutorModal } from './MailReminderExecutorModal';

export const MailReminderExecutor = createDocModalExecutor<IMailReminderExecutorProps>({
    modal: MailReminderExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
        prefilledText: '',
    }),
});
